const copyRightsConstantAR = {
  text: 'حقوق الطبع والنشر {{year}}. جميع الحقوق محفوظة  لـ سيما',
};

export default copyRightsConstantAR;
